// extracted by mini-css-extract-plugin
export default {"container":"eLqK3","content":"FRpSM","body":"C8zIH","header":"nw7Ix"};